// extracted by mini-css-extract-plugin
export default {"form":"FeedbackForm_form__fE+8U","textarea":"FeedbackForm_textarea__j1yDH","templates":"FeedbackForm_templates__6f-HA"};